var render, staticRenderFns
import script from "./PopupView.vue?vue&type=script&lang=js"
export * from "./PopupView.vue?vue&type=script&lang=js"
import style0 from "./PopupView.vue?vue&type=style&index=0&id=47c43f06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c43f06",
  null
  
)

export default component.exports